import React from 'react';
import './HandleBookings.css';
import { ImNewTab } from "react-icons/im";

export default function HandleBookings() {
  return (
    <div className="handle-bookings-container">
      <div className="page-header">
        <h1>Handle Bookings</h1>
        <p>Manage and process bookings</p>
      </div>
      
      <div className="page-content">
        <p>
          To open Treeckle in another tab,{" "}
          <a
            href="https://treeckle.com"
            target="_blank"
            rel="noopener noreferrer"
            className="treekle-link"
          >
            click here <ImNewTab />
          </a>
        </p>
        <div className="iframe-wrapper">
          <iframe
            src="https://treeckle.com/"
            title="Treeckle"
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
}



